import client from "./client";

export const platformGreetingVoices = async () => (await client.get("/platform/greeting/voices")).data;
export const savePlatformGreetingVoices = async (body) => (await client.put("/platform/greeting/voices", body)).data;
export const tryGreetingVoice = async (body) => (await client.post("/platform/greeting/try", body)).data;
export const setPlatformGreetingEnabled = async (enabled) =>
  (await client.put("/platform/greeting/enabled", { enabled })).data;
